import { allTrackers } from "app/services/track/track";

const PERFORMANCE_PREFIX = "bootstrap";

export type BootstrapPhase =
    | "i18n-settings"
    | "swSettings-ready"
    | "store"
    | "identities"
    | "growthbook"
    | "react-chunk"
    | "react-chunk-legacy";

const phaseStartTimes = new Map<BootstrapPhase, number>();

const canUsePerformance =
    typeof performance !== "undefined" &&
    typeof performance.mark === "function" &&
    typeof performance.measure === "function";

const now = (): number =>
    typeof performance !== "undefined" && typeof performance.now === "function" ? performance.now() : Date.now();

export const startBootstrapPhase = (phase: BootstrapPhase): void => {
    const markName = `${PERFORMANCE_PREFIX}:${phase}`;

    if (canUsePerformance) {
        performance.mark(`${markName}:start`);
    }

    phaseStartTimes.set(phase, now());
};

export const endBootstrapPhase = (phase: BootstrapPhase): void => {
    const markName = `${PERFORMANCE_PREFIX}:${phase}`;

    if (canUsePerformance) {
        performance.mark(`${markName}:end`);
        try {
            performance.measure(markName, `${markName}:start`, `${markName}:end`);
        } catch {
            // Start mark may be missing if performance was unavailable when the phase began.
        }
    }

    const startTime = phaseStartTimes.get(phase);
    if (startTime === undefined) {
        return;
    }
    phaseStartTimes.delete(phase);
    const durationInSeconds = (now() - startTime) / 1000;

    allTrackers.dispatchTrackEvent("Bootstrap", "Phase Completed", phase, {
        "Duration In Seconds": durationInSeconds,
    });
};
